export const assumptionsValidation = {
  description: {
    type: 'string',
    required: true,
    maxSize: 65000,
  },
  assignedRole: {
    type: 'string',
    required: true,
  },
  status: {
    type: 'string',
    required: true,
  },
  requestException: {
    type: 'boolean',
  },
  exceptionReason: {
    type: 'string',
    required: {
      value: true,
      when: {
        $requestException: { eq: true },
      },
    },
  },
  exceptionUntilDate: {
    type: 'date',
    required: {
      value: true,
      when: {
        $requestException: { eq: true },
      },
    },
  },
};
